(function ($) {
    function moveSearch() {
        $(".page-template-landing-directory .site__title--mobile ").append(
            $("#directory-search")
        );
    }

    function restoreSearch() {
        if (
            $(
                ".page-template-landing-directory .widget_secondary_nav #directory-search"
            ).length < 1
        ) {
            $(
                ".page-template-landing-directory .widget_secondary_nav "
            ).prepend($("#directory-search"));
        }
    }

    $(document).ready(function () {
        if ($(".menu--secondary") || $(".widget_secondary_nav")) {
            $(".content-container").addClass("include-sticky-sidebar");
        }
    });

    // Laptop/Desktop:
    // Restructure header to include brand bar and site bar
    enquire.register("screen and (min-width: 960px)", {
        // =====================================================
        // Triggered when a media query matches
        // =====================================================
        match: function () {
            restoreSearch();
        },

        // =====================================================
        // Triggered when a media query transitions from a
        // matched state to an unmatched state
        // =====================================================
        unmatch: function () {
            moveSearch();
        },

        // =====================================================
        // Triggered once, when the handler is registered
        // =====================================================
        setup: function () {
            moveSearch();
        },
    });
})(jQuery);
